interface SettingsToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  isDark: boolean;
  testId?: string;
}

export function SettingsToggle({
  checked,
  onChange,
  disabled = false,
  isDark,
  testId,
}: SettingsToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      data-testid={testId}
      onClick={() => onChange(!checked)}
      disabled={disabled}
      className={`relative inline-flex h-7 w-12 shrink-0 items-center rounded-full border-2 border-ink transition-colors ${
        checked ? "bg-mint" : isDark ? "bg-black" : "bg-gray-100"
      } ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
    >
      <span
        className={`inline-block h-5 w-5 transform rounded-full border-2 border-ink bg-white shadow-[0_2px_0_var(--color-ink)] transition-transform ${
          checked ? "translate-x-5.5" : "translate-x-0.5"
        }`}
      />
    </button>
  );
}
